import React from "react";

import {
  useLocation,
} from "react-router-dom";

import {
  FiMenu,
  FiBriefcase,
  FiHome,
  FiCpu,
  FiShield,
} from "react-icons/fi";

import SafeIcon from "../../common/SafeIcon";
import { useClient } from "../../context/ClientContext";

/* =========================================================
   PROFITYO CLIENT HEADER

   Used exclusively inside ClientLayout.

   - Displays the client's active organization
   - Mobile navigation support
   - Client Workspace indicator
   - Sign Out is managed in ClientSidebar
========================================================= */

export default function ClientHeader({
  onMenuClick = () => {},
}) {
  const location = useLocation();

  const {
    activeWorkspace,
    activeClient,
  } = useClient();

  const organizationName =
    activeWorkspace?.name ||
    activeClient?.name ||
    "Your Organization";

  const isAIPage =
    location.pathname === "/client/ai";

  const pageTitle = isAIPage
    ? "AI Copilot"
    : "Client Dashboard";

  const PageIcon = isAIPage
    ? FiCpu
    : FiHome;

  return (
    <header className="relative z-30 flex h-[68px] w-full shrink-0 items-center border-b border-slate-200 bg-white/95 px-4 backdrop-blur-sm sm:px-5 lg:px-8">

      <div className="flex w-full min-w-0 items-center justify-between gap-3">

        {/* LEFT: MOBILE MENU + ORGANIZATION */}

        <div className="flex min-w-0 flex-1 items-center gap-3">

          {/* MOBILE MENU BUTTON */}

          <button
            type="button"
            onClick={onMenuClick}
            aria-label="Open client navigation"
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-slate-600 transition-colors hover:bg-slate-100 md:hidden"
          >
            <SafeIcon
              icon={FiMenu}
              className="text-xl"
            />
          </button>

          {/* ORGANIZATION ICON */}

          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-emerald-100 bg-emerald-50 text-emerald-700">
            <SafeIcon
              icon={FiBriefcase}
              className="text-lg"
            />
          </div>

          {/* ORGANIZATION INFORMATION */}

          <div className="min-w-0">
            <h1
              title={organizationName}
              className="truncate text-sm font-bold text-slate-900"
            >
              {organizationName}
            </h1>

            <div className="mt-1 flex items-center gap-1.5 text-[11px] text-slate-500">
              <SafeIcon icon={PageIcon} />

              <span className="truncate">
                {pageTitle}
              </span>
            </div>
          </div>
        </div>

        {/* RIGHT: CLIENT WORKSPACE INDICATOR */}

        <div className="flex shrink-0 items-center">

          <div className="flex items-center gap-2 rounded-lg border border-emerald-100 bg-emerald-50 px-3 py-2 text-[11px] font-medium text-emerald-800">
            <SafeIcon
              icon={FiShield}
              className="text-sm"
            />

            <span className="hidden sm:inline">
              Client Workspace
            </span>

            <span className="sm:hidden">
              Client
            </span>
          </div>

        </div>
      </div>
    </header>
  );
}